import { DARK_MODE } from "./dark-mode";

export const Facebook = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <style>{DARK_MODE}</style>
    <g clipPath="url(#clip0_244_1220)">
      <path
        d="M8 0.0410004C3.582 0.0410004 0 3.623 0 8.041C0 12.0517 2.95467 15.3637 6.804 15.9423V10.161H4.82467V8.05833H6.804V6.659C6.804 4.34233 7.93267 3.32567 9.858 3.32567C10.78 3.32567 11.268 3.39433 11.4987 3.425V5.26033H10.1853C9.368 5.26033 9.08267 6.03567 9.08267 6.909V8.05833H11.478L11.1533 10.161H9.08267V15.959C12.9873 15.4297 16 12.091 16 8.041C16 3.623 12.418 0.0410004 8 0.0410004Z"
        fill="#1877F2"
      />
    </g>
    <defs>
      <clipPath id="clip0_244_1220">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
